import Modal from "@/components/modal";
import { Box, Typography, Button, Stack } from "@mui/material";
import DateRangePicker from "@/components/date-range-picker";

const DateModal = ({ open, handleClose, handleDateChange, handleApply, dateState }) => {
  const canApply = dateState[0]?.startDate && dateState[0]?.endDate;

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="date-modal-title"
      aria-describedby="date-modal-description"
      style={{ maxWidth: "fit-content" }}
    >
      <Typography
        variant="h6"
        sx={{
          mb: 2,
        }}
      >
        Choose date range
      </Typography>

      <Box sx={{ width: "100%" }}>
        <DateRangePicker onChange={handleDateChange} state={dateState} />
      </Box>

      <Stack direction="row" spacing={2} justifyContent="flex-end" sx={{ mt: 2 }}>
        <Button
          variant="outlined"
          onClick={handleClose}
          sx={{
            textTransform: "none",
          }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleApply}
          disabled={!canApply}
          sx={{
            textTransform: "none",
          }}
        >
          Apply
        </Button>
      </Stack>
    </Modal>
  );
};

export default DateModal;
